export const CSS = {
  actionBarContainer: "action-bar-container",
  content: "content",
};

export const SLOTS = {
  actionBar: "action-bar",
};
